import { PageTitle } from '../../../../shared/components/page-components/PageTitle';
import { ContactListBreadcrumb } from '../breadcrumbs/ContactListBreadcrumb';

export const ContactAddPageNav = (): React.ReactElement<any, any> | null => {
    return (
        <PageTitle>
            <ContactListBreadcrumb />
            Add
        </PageTitle>
    );
};
